<!--
/**
* @name: List.vue
* @description: 余额变动申请列表
* @author: 杨波
* @create: 2020/12/21 15:22:33
* @update: 2020/12/21 15:22:33
*/
-->
<template>
  <y-view :loading="isLoading">
    <y-query spaceBetween :hasSearchButton="false" @search="onSearch">
      <y-query-item>
        <k-input :class="css.inputW" placeholder="请输入交易单号" clearable v-model="para.artificialNo"></k-input>
      </y-query-item>
      <y-query-item>
        <k-input :class="css.inputW" placeholder="请输入门店编码" clearable v-model="para.shopCode"></k-input>
      </y-query-item>
      <y-query-item>
        <k-input :class="css.inputW" placeholder="请输入门店名称" clearable v-model="para.shopName"></k-input>
      </y-query-item>
      <y-query-item slot="right">
        <y-button icon="k-icon-add" @click="onAdd">新增申请</y-button>
      </y-query-item>
    </y-query>
    <y-query spaceBetween :hasSearchButton="false" @search="onSearch">
      <y-query-item>
        <k-input :class="css.inputW" placeholder="请输入会员账号" clearable v-model="para.shopMemberAccount"></k-input>
      </y-query-item>
      <y-query-item>
        <k-input :class="css.inputW" placeholder="请输入会员名称" clearable v-model="para.shopMemberName"></k-input>
      </y-query-item>
      <y-query-item>
        <k-select :class="css.inputW" placeholder="请选择交易类型" clearable v-model="para.artificialType">
          <k-option v-for="item in tradeTypeList" :key="item.code" :value="item.code" :label="item.name">{{ item.name }}</k-option>
        </k-select>
      </y-query-item>
    </y-query>
    <y-query spaceBetween :hasSearchButton="false" @search="onSearch">
      <y-query-item>
        <k-select :class="css.inputW" placeholder="请选择审核状态" clearable v-model="para.status">
          <k-option v-for="item in verifyStatusList" :key="item.code" :value="item.code" :label="item.name">{{ item.name }}</k-option>
        </k-select>
      </y-query-item>
      <y-query-item>
        <k-select :class="css.inputW" placeholder="请选择销售渠道" clearable v-model="para.saleChannelCode">
          <k-option v-for="item in channelList" :key="item.code" :value="item.code" :label="item.name">{{ item.name }}</k-option>
        </k-select>
      </y-query-item>
      <y-query-item>
        <DatePicker
          :editable="false"
          type="datetimerange"
          @on-change="changeCreateDate"
          :value="createData"
          format="yyyy-MM-dd HH:mm:ss"
          placeholder="请选择创建时间"
          style="width: 280px;"
        ></DatePicker>
      </y-query-item>
    </y-query>
    <y-query spaceBetween :hasSearchButton="false" @search="onSearch">
      <y-query-item>
        <DatePicker
          :editable="false"
          type="datetimerange"
          @on-change="changeVerifyDate"
          :value="verifyData"
          format="yyyy-MM-dd HH:mm:ss"
          placeholder="请选择审核时间"
          style="width: 280px;"
        ></DatePicker>
      </y-query-item>
      <y-query-item>
        <k-button type="primary" @click="onSearch">查询</k-button>
      </y-query-item>
      <y-query-item>
        <k-button @click="onReset">重置</k-button>
      </y-query-item>
    </y-query>
    <k-table :data="applyList" :height="$root.tableHeightXXXX" :rightFixedNumber="1" :columns="initColumns()"></k-table>
    <k-pagination :total="total" :current-page.sync="para.pageCurrent" :page-size.sync="para.pageSize" @page-change="onChangePageIndex" />
    <k-popup :show.sync="isShowLog" title="余额变动申请日志" layout="header, body, mask, close">
      <y-popup-body size="big">
        <k-table :data="logData" :columns="initLogColumns()"></k-table>
      </y-popup-body>
    </k-popup>
    <k-popup :show.sync="isShowPopup" title="余额变动申请基本信息" okText="保存" @after-cancel="onCancelInfo" @after-ok="onSaveInfo">
      <y-popup-body size="small">
        <y-form titleWidth="90px" titleAlign="left">
          <y-form-item title="门店编码：">
            <k-input :class="css.inputW" placeholder="请输入门店编码" clearable v-model="editPara.shopCode"></k-input>
          </y-form-item>
          <y-form-item title="会员账号：">
            <k-input :class="css.inputW" placeholder="请输入会员账号" clearable v-model="editPara.shopMemberAccount"></k-input>
          </y-form-item>
          <y-form-item title="交易类型：" required>
            <div>
              <k-radio v-model="editPara.artificialType" :value="1">充值</k-radio>
              <k-radio v-model="editPara.artificialType" :value="-1">金额扣减</k-radio>
            </div>
          </y-form-item>
          <y-form-item title="金额：" required>
            <k-input @keydown.native="clearInput" type="number" min="0" :class="css.inputW" placeholder="请输入金额，最多两位小数" clearable v-model="editPara.amount"></k-input>
          </y-form-item>
          <y-form-item title="金额用途：" required>
            <k-select :class="css.inputW" placeholder="请选择金额用途" v-model="editPara.accountSubType" block clearable>
              <k-option v-for="item in useTypeList" :key="item.code" :value="item.code" :label="item.name">{{ item.name }}</k-option>
            </k-select>
          </y-form-item>
          <y-form-item title="备注：" align="top">
            <k-input tag="textarea" v-model="editPara.comment" block placeholder="请输入备注..." :class="css.textarea"></k-input>
          </y-form-item>
        </y-form>
      </y-popup-body>
    </k-popup>
  </y-view>
</template>
<script>
import {
  NESTLE_FINANCE_BACK_SERVER_ARTIFICIAL_LIST,
  NESTLE_FINANCE_BACK_SERVER_ARTIFICIAL_LIST_OPTIONS,
  NESTLE_FINANCE_BACK_SERVER_ARTIFICIAL_ACCEPT,
  NESTLE_FINANCE_BACK_SERVER_ARTIFICIAL_DISCARD,
  NESTLE_FINANCE_BACK_SERVER_ARTIFICIAL_LOGS,
  NESTLE_FINANCE_BACK_SERVER_ARTIFICIAL_APPLY,
} from "@/assets/modules/apiList";
const initPara = () => ({
  artificialNo: "",
  shopCode: "",
  shopName: "",
  shopMemberAccount: "",
  shopMemberName: "",
  artificialType: "",
  status: "",
  saleChannelCode: "",
  createStartTime: "",
  createEndTime: "",
  acceptStartTime: "",
  acceptEndTime: "",
  pageCurrent: 1,
  pageSize: 15,
});
const initEditPara = () => ({
  shopCode: "",
  shopMemberAccount: "",
  artificialType: "",
  amount: "",
  accountSubType: "",
  comment: "",
});
export default {
  data() {
    return {
      isLoading: false,
      isShowPopup: false,
      isSaving: false,
      isShowLog: false,
      para: initPara(),
      editPara: initEditPara(),
      useTypeList: [{ code: 1, name: "资金余额" }],
      tradeTypeList: [],
      verifyStatusList: [],
      logData: [],
      channelList: [],
      verifyData: "",
      createData: "",
      applyList: [],
      total: 0,
    };
  },
  methods: {
    initColumns() {
      return [
        {
          name: "交易单号",
          field: "artificialNo",
          style: {
            width: 120,
            textAlign: "center",
            "line-height": "18px",
            "white-space": "normal",
            "word-break": "break-all",
          },
        },
        {
          name: "门店编码",
          field: "shopCode",
          style: {
            width: 80,
            textAlign: "center",
          },
        },
        {
          name: "门店名称",
          field: "shopName",
          style: {
            width: 120,
            textAlign: "center",
            "line-height": "18px",
            "white-space": "normal",
            "word-break": "break-all",
          },
        },
        {
          name: "会员账号",
          field: "shopMemberAccount",
          style: {
            width: 100,
            textAlign: "center",
            "line-height": "18px",
            "white-space": "normal",
          },
        },
        {
          name: "会员名称",
          field: "shopMemberName",
          style: {
            width: 80,
            textAlign: "center",
            "line-height": "18px",
            "white-space": "normal",
          },
        },
        {
          name: "金额",
          field: "amount",
          style: {
            width: 80,
            textAlign: "center",
            "line-height": "18px",
            "white-space": "normal",
          },
        },
        {
          name: "交易类型",
          field: "artificialTypeDesc",
          style: {
            width: 100,
            textAlign: "center",
            "line-height": "18px",
            "white-space": "normal",
          },
        },
        {
          name: "金额用途",
          field: "accountSubTypeDesc",
          style: {
            width: 100,
            textAlign: "center",
            "line-height": "18px",
            "white-space": "normal",
          },
        },
        {
          name: "销售渠道",
          field: "saleChannelName",
          style: {
            width: 100,
            textAlign: "center",
            "line-height": "18px",
            "white-space": "normal",
          },
        },
        {
          name: "备注",
          field: "comment",
          style: {
            width: 100,
            textAlign: "center",
            "line-height": "18px",
            "white-space": "normal",
          },
        },
        {
          name: "审核状态",
          field: "statusDesc",
          style: {
            width: 100,
            textAlign: "center",
            "line-height": "18px",
            "white-space": "normal",
          },
        },
        {
          name: "操作人",
          field: "createBy",
          style: {
            width: 100,
            textAlign: "center",
            "line-height": "18px",
            "white-space": "normal",
          },
        },
        {
          name: "创建时间",
          field: "createTime",
          style: {
            width: 100,
            textAlign: "center",
            "line-height": "18px",
            "white-space": "normal",
          },
        },
        {
          name: "审核时间",
          field: "acceptTime",
          style: {
            width: 100,
            textAlign: "center",
            "line-height": "18px",
            "white-space": "normal",
          },
        },
        {
          name: "操作",
          field: "",
          style: {
            width: 150,
            textAlign: "center",
          },
          customRender: (row) => {
            const viewButton = (
              <a
                href="javascript:void(0);"
                onClick={() => {
                  this.onView(row);
                }}
              >
                查看
              </a>
            );
            const auditButton = (
              <a
                href="javascript:void(0);"
                onClick={() => {
                  this.onAudit(row);
                }}
              >
                审核
              </a>
            );
            const cancelButton = (
              <a
                href="javascript:void(0);"
                onClick={() => {
                  this.onCancel(row);
                }}
              >
                作废
              </a>
            );
            const viewLogButton = (
              <a
                href="javascript:void(0);"
                onClick={() => {
                  this.onViewLog(row);
                }}
              >
                日志
              </a>
            );
            if (row.status == "2") {
              return (
                <div>
                  {viewButton}&#12288;{viewLogButton}&#12288;{auditButton}&#12288;{cancelButton}
                </div>
              );
            } else {
              return (
                <div>
                  {viewButton}&#12288;{viewLogButton}
                </div>
              );
            }
          },
        },
      ];
    },
    initLogColumns() {
      return [
        {
          name: "创建时间",
          field: "createTime",
          style: {
            width: 100,
            textAlign: "center",
            "line-height": "18px",
            "white-space": "normal",
          },
        },
        {
          name: "创建人",
          field: "createBy",
          style: {
            width: 100,
            textAlign: "center",
            "line-height": "18px",
            "white-space": "normal",
          },
        },
        {
          name: "操作",
          field: "description",
          style: {
            width: 100,
            textAlign: "center",
            "line-height": "18px",
            "white-space": "normal",
          },
        },
        {
          name: "内容",
          field: "content",
          style: {
            width: 100,
            textAlign: "center",
            "line-height": "18px",
            "white-space": "normal",
          },
        },
        {
          name: "备注",
          field: "remark",
          style: {
            width: 100,
            textAlign: "center",
            "line-height": "18px",
            "white-space": "normal",
          },
        },
      ];
    },
    clearInput(e) {
      let key = e.key;
      if (key === "e" || key === "E" || key === "+" || key === "-") {
        e.returnValue = false;
        return false;
      }
      if (this.editPara.amount.indexOf(".") > 0) {
        if (key === ".") {
          e.returnValue = false;
          return false;
        }
      }
      return true;
    },
    onAdd() {
      this.editPara = initEditPara();
      this.isShowPopup = true;
    },
    onView(row) {
      const { id } = row;
      this.$controller.open({
        name: "surplusApplyDetailManagement",
        query: {
          refresh: new Date() - 0,
          id,
        },
      });
    },
    onCancelInfo() {
      this.isShowPopup = false;
    },
    onSaveInfo() {
      let { tip } = this.$root;
      if (this.isSaving) {
        return;
      }
      let para = JSON.parse(JSON.stringify(this.editPara));
      if (!para.shopCode && !para.shopMemberAccount) {
        return tip("门店编码、会员账号必填其中一个");
      }
      if (para.shopCode && para.shopMemberAccount) {
        return tip("门店编码、会员账号不能同时填写");
      }
      if (!para.artificialType) {
        return tip("请选择交易类型");
      }
      if (!para.amount) {
        return tip("请输入金额");
      } else {
        if (para.amount.indexOf(".") > 0 && para.amount.split(".")[1].length > 2) {
          return tip("金额最多输入两位小数");
        }
      }
      if (!para.accountSubType) {
        return tip("请选择金额用途");
      }
      this.isSaving = true;
      this.isLoading = false;
      this.$fetch({
        api: NESTLE_FINANCE_BACK_SERVER_ARTIFICIAL_APPLY,
        para,
      })
        .then((res) => {
          this.isSaving = false;
          this.isLoading = false;
          tip("保存成功");
          this.getApplyList();
          this.isShowPopup = false;
        })
        .catch(() => {
          this.isSaving = false;
          this.isLoading = false;
        });
    },
    changeCreateDate(date) {
      this.createData = date;
    },
    changeVerifyDate(date) {
      this.verifyData = date;
    },
    onViewLog(row) {
      let { id } = row;
      this.$fetch({
        api: NESTLE_FINANCE_BACK_SERVER_ARTIFICIAL_LOGS,
        para: { id },
      }).then((res) => {
        this.isShowLog = true;
        this.logData = res || [];
      });
    },
    onSearch() {
      this.para.pageCurrent = 1;
      this.getApplyList();
    },
    onChangePageIndex(p) {
      this.para.pageCurrent = p;
      this.getApplyList();
    },
    onReset() {
      this.para = initPara();
      this.createData = "";
      this.verifyData = "";
      this.getApplyList();
    },
    onAudit(row) {
      this.$dialog({
        title: "提示",
        content: "是否确认审核？",
        ok: () => {
          this.isLoading = true;
          this.$fetch({
            api: NESTLE_FINANCE_BACK_SERVER_ARTIFICIAL_ACCEPT,
            para: { id: row.id },
          })
            .then((res) => {
              this.getApplyList();
              this.isLoading = false;
            })
            .catch(() => {
              this.isLoading = false;
            });
        },
      });
    },
    onCancel(row) {
      this.$dialog({
        title: "提示",
        content: "是否确认作废？",
        ok: () => {
          this.isLoading = true;
          this.$fetch({
            api: NESTLE_FINANCE_BACK_SERVER_ARTIFICIAL_DISCARD,
            para: { id: row.id },
          })
            .then((res) => {
              this.getApplyList();
              this.isLoading = false;
            })
            .catch(() => {
              this.isLoading = false;
            });
        },
      });
    },
    getStatusList() {
      this.$fetch({
        api: NESTLE_FINANCE_BACK_SERVER_ARTIFICIAL_LIST_OPTIONS,
        para: {},
      }).then((res) => {
        this.verifyStatusList = res.statuses || [];
        this.tradeTypeList = res.artificialTypes || [];
        this.channelList = res.saleChannels || [];
      });
    },
    getApplyList() {
      let { para } = this;
      para.createStartTime = this.createData && this.createData.length > 0 ? this.createData[0] : "";
      para.createEndTime = this.createData && this.createData.length > 0 ? this.createData[1] : "";
      para.acceptStartTime = this.verifyData && this.verifyData.length > 0 ? this.verifyData[0] : "";
      para.acceptEndTime = this.verifyData && this.verifyData.length > 0 ? this.verifyData[1] : "";
      this.$fetch({
        api: NESTLE_FINANCE_BACK_SERVER_ARTIFICIAL_LIST,
        para,
      }).then((res) => {
        this.applyList = res.pageList;
        this.total = res.total;
      });
    },
  },
  created() {
    this.getApplyList();
    this.getStatusList();
  },
  beforeRouteUpdate(to, from, next) {
    this.getApplyList();
    next();
  },
};
</script>
<style lang="postcss" module="css">
.inputW {
  width: 280px !important;
}
.textarea {
  width: 280px !important;
  height: 100px;
  & :global(.k-textarea) {
    height: 100px !important;
    resize: none;
  }
}
</style>
